export default (nominal: number): string => `${Number(nominal).toLocaleString('id-ID')}`
